import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import Icon from '@ailibs/feather-react-ts';
import { withTranslation } from 'react-i18next';
import { withRouter, Link } from 'react-router-dom';
import user1 from '../../../assets/images/users/avatar-1.jpg';
import { useSelector, useDispatch } from 'react-redux';
import { viewProfile } from '../../../store/auth/profile/actions';

const ProfileMenu = (props: any) => {
    const { success } = useSelector((state: any) => ({
        success: state.profile.success,
    }));

    const { profileData } = useSelector((state: any) => ({
        profileData: state.profile.profileData,
    }));
    const [menu, setMenu] = useState<boolean>(false);
    const dispatch = useDispatch();
    const [username, setusername] = useState('');
    useEffect(() => {
        const getAuthUser = localStorage.getItem('authUser');
        if (getAuthUser) {
            const obj = JSON.parse(getAuthUser);
            setusername(obj.USUARIO_NOMBRE);
        }
    }, [success]);
    const [photo, setPhoto] = useState(user1);

    useEffect(() => {
        const getAuthUser2: any = localStorage.getItem('authUser');
        const obj = JSON.parse(getAuthUser2);
        dispatch(viewProfile(obj));
    }, []);

    useEffect(() => {
        setPhoto(profileData.URL_FOTO_PERFIL);
    }, [profileData]);

    return (
        <React.Fragment>
            <Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className="d-inline-block">
                <DropdownToggle className="btn header-item bg-soft-light border-start border-end" id="page-header-user-dropdown" tag="button">
                    <img className="rounded-circle header-profile-user" src={photo} alt="" />
                    <span className="d-none d-xl-inline-block ms-2 me-1">{username}</span>
                    <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end position-absolute">
                    {
                        <Link to="/profile" className="dropdown-item">
                            <Icon className="font-size-16 align-middle me-1 " name="user" />
                            <span>{props.t('Profile')}</span>
                        </Link>
                    }
                    <div className="dropdown-divider" />
                    <Link to="/logout" className="dropdown-item">
                        <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
                        <span>{props.t('Logout')}</span>
                    </Link>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

ProfileMenu.propTypes = {
    success: PropTypes.any,
    t: PropTypes.any,
};
export default withTranslation()(withRouter(ProfileMenu));
